import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import InvoiceList from "@/Components/common/client/invoices/InvoiceList";
import { updateactivePages } from "@/reducers/clientcommon";
import {
  fetchClientInvoices,
  resetPage,
  setLoading,
  updateFilters,
} from "@/reducers/clientinvoice";

import InvoiceTypes from "../../Components/common/client/invoices/InvoiceTypes";
import { fetchClientInvoiceCount } from "../../reducers/invoicesCount";
import useTitle from "../../utilities/hooks/useTitle";

/**
 * Renders the Invoice component with session data.
 *
 * @return {JSX.Element} The rendered Invoice component
 */
const Invoice = () => {
  useTitle("Invoices");
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(resetPage());
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(fetchClientInvoiceCount());
    dispatch(
      updateactivePages({
        activePage: "invoices",
        activeSubPage: "invoices",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
    dispatch(setLoading(true));
    dispatch(fetchClientInvoices());
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <InvoiceTypes />
      <InvoiceList />
    </div>
  );
};

export default Invoice;
